import React from 'react';
import {View} from 'react-native';

import Text from '/component/base/Text';
import {DownlineProfile} from '/constant/TestIDs';
import {useTranslation} from '/provider/TranslationProvider';
import testProperties from '/util/testing/testProperties';

import {getFormattedWeeklyCheckInsDate} from '../../ClientJourneyTask.util';
import {TaskItemDescriptionComponent} from '../../TaskItem/TaskItemDescriptionComponent';
import {styles} from '../TaskDetails.style';
interface WeeklyCheckInTaskDetailsProps {
  currentCheckInDate: string | null;
  lastCheckInDate: string | null;
  weeklyCheckInsTasks: [];
  taskStatus: boolean | null;
}

export const WeeklyCheckInTaskDetails: React.FC<
  WeeklyCheckInTaskDetailsProps
> = ({
  currentCheckInDate = null,
  lastCheckInDate = null,
  weeklyCheckInsTasks = [],
  taskStatus = null,
}) => {
  const {tt, ts} = useTranslation(
    'clientProfile.clientJourney.weeklyCheckIns.weeklyCheckIn',
  );

  const renderLastCheckInDate = () => {
    if (
      Array.isArray(weeklyCheckInsTasks) &&
      weeklyCheckInsTasks.length > 0 &&
      (currentCheckInDate || lastCheckInDate)
    ) {
      const weeklyCheckInsDate = taskStatus
        ? getFormattedWeeklyCheckInsDate(currentCheckInDate)
        : getFormattedWeeklyCheckInsDate(lastCheckInDate);
      return (
        <TaskItemDescriptionComponent
          description={ts(
            'weeklyCheckInsText',
            `Completed ${weeklyCheckInsDate}`,
          )}
          style={styles.lastCheckInDateText}
        />
      );
    } else {
      return (
        <TaskItemDescriptionComponent
          description={ts('weeklyCheckInsText', 'Repeats every week')}
          style={styles.lastCheckInDateText}
        />
      );
    }
  };

  return (
    <>
      {renderLastCheckInDate()}
      <View style={styles.taskDetailsContent}>
        {tt('details', () => (
          <Text
            variant="button"
            style={styles.taskDetailContentText}
            {...testProperties(DownlineProfile.cjTaskDetailsText)}>
            Continue check-ins with each of your active Clients to assist them
            on their journey through the Habits of Health Transformational
            System.
          </Text>
        ))}
      </View>
    </>
  );
};
